import React from 'react';
import './Avatar.css';

const PALETTE = ['#3B9FE0', '#7c3aed', '#ea580c', '#059669', '#d4a900'];

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
}

function initialsFromEmail(email: string): string {
  const local = email.split('@')[0] ?? '';
  const segments = local.split(/[._-]/).filter(Boolean);
  if (segments.length >= 2) {
    return (segments[0][0] + segments[1][0]).toUpperCase();
  }
  return local.slice(0, 2).toUpperCase();
}

interface AvatarProps {
  email: string;
}

const Avatar: React.FC<AvatarProps> = ({ email }) => {
  const color = PALETTE[hashString(email) % PALETTE.length];
  return (
    <span className="dashboard-avatar" style={{ background: color }} aria-hidden="true">
      {initialsFromEmail(email)}
    </span>
  );
};

export default Avatar;
